<template>
  <component
    v-if="getArtObjectComponent()"
    :is="getArtObjectComponent()"
    :type="props.type"
    :payload="props.payload"
    :parent-ident="props.parentIdent"
  />
</template>

<script setup lang="ts">
const logger = useFrontendLogger()

const props = defineProps({
  type: { type: String, required: true },
  payload: { type: Object, required: false },
  parentIdent: { type: String, required: false },
})

const {isHiddenArtObject} = useArticleEmbeds()

const getArtObjectComponent = () => {
  if (isHiddenContent()) {
    // log to sentry
    // logger.addTag('artObject.type', props.type || 'unknown').info('ArtObject hidden by filter', {
    //   ArtObjectType: props.type,
    //   ParentIdent: props.parentIdent,
    //   Payload: props.payload,
    // })
    return
  }

  switch (props.type) {
    // Basic common ArtObjects
    case 'div':
    case 'paragraph':
    case 'factbox':
      return resolveComponent('DefaultArticlesArtObjectsBasic')
    case 'reference':
      return resolveComponent('DefaultArticlesArtObjectsReference')
    case 'souteze':
      return resolveComponent('DefaultArticlesArtObjectsSurvey')
    case 'table':
      return resolveComponent('DefaultArticlesArtObjectsTable')
    case 'heading':
      return resolveComponent('DefaultArticlesArtObjectsHeading')
    case 'youtube_embed':
      return resolveComponent('DefaultArticlesArtObjectsYoutubeEmbed')
    case 'ordered_list':
      return resolveComponent('DefaultArticlesArtObjectsOrderedList')
    case 'bullet_list':
      return resolveComponent('DefaultArticlesArtObjectsBulletList')
    case 'vimeo_embed':
      return resolveComponent('DefaultArticlesArtObjectsVimeoEmbed')
    case 'media':
      return resolveComponent('DefaultArticlesArtObjectsMedia')
    case 'page_break':
      return resolveComponent('DefaultArticlesArtObjectsPageBreak')
    case 'quote':
      return resolveComponent('DefaultArticlesArtObjectsQuote')
    case 'iframe':
      return resolveComponent('DefaultArticlesArtObjectsIframe')
    case 'cnc_html_box':
      return resolveComponent('DefaultArticlesArtObjectsCncHtmlBox')
    case 'instagram_embed':
      return resolveComponent('DefaultArticlesArtObjectsInstagramEmbed')
    case 'line_break':
      return resolveComponent('DefaultArticlesArtObjectsLineBreak')
    case 'twitter_embed':
      return resolveComponent('DefaultArticlesArtObjectsTwitterEmbed')
    case 'tiktok_embed':
      return resolveComponent('DefaultArticlesArtObjectsTikTokEmbed')
    case 'facebook_embed':
      return resolveComponent('DefaultArticlesArtObjectsFacebookEmbed')
    case 'cnc_simple_artobject':
      return resolveComponent('DefaultArticlesArtObjectsCncSimpleArtobject')
    case 'spotify_podcast':
      return resolveComponent('DefaultArticlesArtObjectsSpotifyPodcast')
    case 'bold':
      return resolveComponent('DefaultArticlesArtObjectsBold')
    case 'italic':
      return resolveComponent('DefaultArticlesArtObjectsBasic')
    case 'text':
    case 'span':
      return resolveComponent('DefaultArticlesArtObjectsText')
    default:
      // log to sentry
      logger.addTag('artObject.type', props.type || 'unknown').info('ArtObject not supported', {
        ArtObjectType: props.type,
        ParentIdent: props.parentIdent,
        Payload: props.payload,
      })
  }
  return null
}

// Shared with the embed counting in ArticleDetail.vue — the counter has to skip
// exactly what this gate drops, otherwise it reports embeds that never render.
const isHiddenContent = () => isHiddenArtObject(props.payload)
</script>
